import { multimediaEpaycoUrl } from "../../utils/multimedia";
import { REACT_APP_SECURE } from "../../config/env";
import React, { Component } from "react";
import { colors, Elastic, Flex, MyCampo, Mycard, Transition } from "../ui";
import { Btn } from "./../UI-Components/Btn";
import { css } from "@emotion/core";
import { FooterFactura, Line } from "../pagaFactura";
import ReactTooltip from "react-tooltip";
import { withRouter } from "react-router";
import { animated, useTransition } from "react-spring";
import styled from "@emotion/styled";
import { b64toBlob, serviceApi, serviceApiResponse, getDataTransactionUrl } from "../ServiciosMaestros/request";
import { lookupTransaction } from "../ServiciosMaestros/transactionLookup";
import { reportRespuestaError } from "../ServiciosMaestros/handleIntegrationError";
import { api } from "../ServiciosMaestros/apis";
import SimpleReactValidator from "simple-react-validator";

const ShowEmail = ({ email, loading, show, downloadPdf, print, onChangeInputText, sendEmail, loadingEmail, url_respuesta, enviado = false, error = "" }) => {


    const transitions = useTransition(email, null, {
        from: { opacity: 0, transform: email ? "translateX(-100%)" : "translateX(100%)" },
        enter: { opacity: 1, transform: "translateX(0)" },
        leave: { opacity: 0, position: "absolute", transform: email ? "translateX(100%)" : "translateX(-100%)" },
    });
    return (
        transitions.map(({ item, key, props }) =>
            item
                ?
                <animated.div style={props} className="col-12  pl-md-0">
                    <Flex alg={"flex-end"}>
                        <div className="col-12 col-sm-6 px-0 ">
                            <MyCampo
                                type={"text"}
                                name={"textEmail"}
                                label={enviado ? "¡Correo enviado exitosamente! " : "Enviar una copia al email"}
                                disabled={loadingEmail}
                                placeholder={"Ingrese su email"}
                                onchange={(e) => onChangeInputText(e)}
                                enviado={enviado}
                                error={error}
                                maxLeng
                            />
                        </div>
                        <div className="col-12 col-sm-3 px-0 pt-3 pt-sm-0 pl-sm-2 pr-sm-3 line-height-0"
                            onClick={() => sendEmail()}>
                            <Btn
                                bg
                                hg={"45"}
                                loading={loadingEmail}
                                disabled={loadingEmail}

                            >Enviar</Btn>
                        </div>
                        <div className="col-12 col-sm-3 px-0 pt-3 pt-sm-0">
                            <Btn
                                bg
                                hg={"45"}
                                onClick={show}
                            >
                                Otras opciones
                            </Btn>
                        </div>
                    </Flex>
                </animated.div> :
                <animated.div style={props} className="col-12 px-0 pt-26">
                    <Flex className={"col-12 px-0"}>
                        <div className={url_respuesta.activo ? "col-12 col-md-6 pb-3 pb-md-0 pl-md-0 btn-bar-font" : "col-12 col-md-5 pb-3 pb-md-0 pl-md-0"}>
                            <Btn classNameBtn="btn-vertical-aln" bg hg={"45"} onClick={show}>
                                <img src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/envelope.png")}
                                    alt="" width={"20px"} height={"auto"} className={"mr-2"} />
                                Enviar copia por correo
                            </Btn>
                        </div>
                        <Flex className={url_respuesta.activo ? "col-12 col-md-6 pl-md-0 btn-bar-font" : "col-12 col-md-7 pl-md-0 "}>
                            <div className="col-12 col-sm-6 pb-3 pb-sm-0 px-0 pr-sm-2" onClick={() => print()}>
                                <Btn classNameBtn="btn-vertical-aln" bg hg={"45"}><img
                                    src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/print.png")}
                                    alt="" className={"mr-2"} />Imprimir</Btn>
                            </div>
                            <div className={url_respuesta.activo ? "col-12 col-sm-6 px-0 pl-sm-2 btn-bar-font" : "col-12 col-sm-6 px-0 pl-sm-2"} onClick={() => downloadPdf()}>
                                <Btn
                                    classNameBtn="btn-vertical-aln" bg
                                    hg={"45"}
                                    disabled={loading}
                                    loading={loading}
                                >
                                    <img
                                        src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/download.png")}
                                        alt=""
                                        className={`mr-2`} />Descargar
                                </Btn>
                            </div>
                        </Flex>
                    </Flex>
                </animated.div>)
    )
};

const Alert = styled.div`
        width:100%;
        height:50px;
        background-color: ${props => colors[props.alert]};
        color:white;
        font-size:25px;
        line-height:50px;
        font-weight:300;
        text-align:center;
        border-radius:4px;
 `;

let ruta = {};

class InicioFormulario extends Component {


    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator(
            {
                messages: {
                    required: "Debe ingresar un :attribute",
                    regex: "Debe ingresar una dirección de :attribute válida",
                },
            }
        )
        const url_respuesta = JSON.parse(sessionStorage.getItem("configuracion")).url_respuesta;

        this.state = {
            errorPago: false,
            integrationErrorMessage: "",
            loadingTransaction: true,
            titulo: "",
            informacionEmpresa: {},
            response: {},
            infoFormulario: [],
            infoFormularioCopy: [],
            printState: false,
            email: false,
            loading: false,
            loadingEmail: false,
            textEmail: "",
            url_respuesta: {
                ...{
                    activo: false,
                },
                ...url_respuesta
            },
            existeProductos: false,
            productos: []
        }
        this.loadTransaction = this.loadTransaction.bind(this);

    }


    loadTransaction() {
        ruta = JSON.parse(sessionStorage.getItem("rutas"));

        let titulo = sessionStorage.getItem("titulo");
        let informacionEmpresa = JSON.parse(sessionStorage.getItem("informacion"));
        let infoFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
        let ref_payco = this.getQueryParam('ref_payco');

        if (!infoFormulario || infoFormulario.length === 0) {
            this.props.openModal("No fue posible visualizar la respuesta de la transacción", "danger");
            this.props.history.push(ruta.home);
            return;
        }

        let newInfo = infoFormulario.filter((inf) => {
            return inf.value !== "" && inf.fieldDb !== "productos"
        });
        const prdIndex = infoFormulario.findIndex(el => el.fieldDb === "productos")
        let existeProductos = false;
        let productos = [];
        if (prdIndex >= 0 && typeof prdIndex == "number") {
            const prd = infoFormulario.slice()[prdIndex];
            existeProductos = true;
            productos = JSON.parse(prd.value).map(el => {
                return {
                    name: el.nombre,
                    value: el.count
                }
            });
        }

        this.setState({
            loadingTransaction: true,
            integrationErrorMessage: "",
        });

        lookupTransaction(ref_payco)
            .then(response => {
                if (response.success) {
                    this.setState({
                        titulo,
                        response: response.data,
                        infoFormulario: newInfo,
                        informacionEmpresa,
                        productos,
                        existeProductos,
                        loadingTransaction: false,
                        errorPago: false,
                        integrationErrorMessage: "",
                    });
                } else {
                    this.setState({
                        titulo,
                        errorPago: true,
                        integrationErrorMessage: "",
                        loadingTransaction: false,
                        response: {
                            x_cod_response: 4,
                            x_transaction_state: "Cancelado"
                        }
                    });
                }
            }).catch((error) => {
                reportRespuestaError(this, error, {
                    refPayco: ref_payco,
                    endpoint: `${REACT_APP_SECURE}/${ref_payco}`,
                    statePatch: { titulo },
                });
            });
    }

    componentDidMount() {
        this.loadTransaction();
    }

    actualizarFactura(data) {
        serviceApiResponse({ data }, api.actualizarFacturaConfirmacion, "POST")
            .then((response) => {
            })
            .catch((error) => {
                reportRespuestaError(this, error, {
                    showModal: true,
                    endpoint: api.actualizarFacturaConfirmacion,
                    service: "recaudo-api",
                    setComponentState: false,
                });
            })
    }

    tranformValue(value, type, options, db) {
        if (type === "select" || type === "radio") {
            let info = options.filter((op) => {
                return op.value === value
            })

            return info && info.length > 0 ? info[0].name : "";
        } else if (type === "checkbox") {
            let info = "";
            value.map((v, key) => {
                let valueOption = options.filter((op) => {
                    return op.value === v
                })
                return info += `${valueOption[0].name}${key < value.length - 1 ? ", " : ""}`
            })

            return info;
        } else if (type === "date") {
            let date = new Date(value);
            return `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}`;
        } else if (type === "time") {
            let date = new Date(value);
            return `${date.getHours() > 9 && date.getHours() < 13 ? "" : "0"}${date.getHours() > 12 ? date.getHours() - 12 : date.getHours()}:${date.getMinutes() > 9 ? "" : "0"}${date.getMinutes()} ${date.getHours() > 12 ? "PM" : "AM"}`;
        } else if ((type === "number" && db === "total") || type == "currency") {
            return `$ ${parseFloat(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} COP`;
        } else if (db === "iva") {
            return `$ ${value} COP`
        }
        else {
            return value;
        }

    }

    getQueryParam(param) {
        window.location.search.substr(1)
            .split("&")
            .some(function (item) { // returns first occurence and stops
                return item.split("=")[0] == param && (param = item.split("=")[1])
            })
        return param
    }

    verificarEstadoTransaccion(estado) {
        if (estado == 1) {
            return "alertG";
        } else if (estado == 2) {
            return "alertR"
        } else if (estado == 3) {
            return "alertY"
        } else if (estado == 4) {
            return "alertR"
        }
    }

    validateStatus() {
        switch (this.state.response.x_transaction_state) {
            case 'Aceptada':
                return 'Aceptado';
                break;
            case 'Rechazada':
                return 'Rechazado';
                break;
            case 'Fallida':
                return 'Fallido';
                break;
            case 'Reversada':
                return 'Reversado';
                break;
            case 'Retenida':
                return 'Retenido';
                break;
            case 'Iniciada':
                return 'Iniciado';
                break;
            case 'Exprirada':
                return 'Expirado';
                break;
            case 'Abandonada':
                return 'Abandonado';
                break;
            case 'Cancelada':
                return 'Cancelado';
                break;
            default:
                return this.state.response.x_transaction_state
                break;
        }
    }

    downloadPdf() {
        sessionStorage.getItem("param");
        let infoFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
        let inputs = infoFormulario.filter((inf) => {
            return inf.value !== ""
        });
        const data = {
            informacion: JSON.parse(sessionStorage.getItem("informacion")),
            transaccion: this.state.response,
            respuesta: this.state.response.x_cod_response,
            inputs
        };

        this.setState({ loading: true });
        serviceApiResponse(data, `${api.exportar}`, "POST")
            .then(response => {
                if (response.success) {
                    const contentType = response.data.contentType;
                    const b64Data = response.data.ruta;

                    const blob = b64toBlob(b64Data, contentType);
                    const blobUrl = URL.createObjectURL(blob);

                    let element = document.getElementById('pdf');
                    element.setAttribute('href', blobUrl);
                    element.setAttribute('download', response.data.nombre);
                    element.click();
                }
                this.setState({ loading: false });
            })
            .catch(error => {
                reportRespuestaError(this, error, {
                    showModal: true,
                    endpoint: api.exportar,
                    service: "recaudo-api",
                    setComponentState: false,
                });
                this.setState({ loading: false });
            });
    }

    print() {
        this.setState({ printState: true }, () => {
            window.print();
            setTimeout(
                () => {
                    this.setState({ printState: false });
                },
                100
            );
        });
    }

    onChangeInputText(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState({
            [name]: value,
        })
    }

    sendEmail() {
        const { response, textEmail } = this.state;
        if (this.validator.allValid()) {
            this.setState({ loadingEmail: true });
            serviceApi({}, getDataTransactionUrl() + `?transaction_id=${response.x_ref_payco}&email_adicional=${textEmail}`, 'POST')
                .then(result => {
                    if (result.success === "ok") {
                        this.setState({
                            enviado: true,
                            email: ""
                        }, () => {
                            setTimeout(() => {
                                this.setState({ enviado: false })
                            }, 10000)
                        });
                        // this.messageToast("Correo enviado exitosamente", "success");
                    } else {
                        // this.messageToast("No se pudo enviar el correo electrónico", "error");
                    }
                    this.setState({ loadingEmail: false });
                })
                .catch(error => {
                    reportRespuestaError(this, error, {
                        showModal: true,
                        endpoint: "email/transaccion",
                        service: "recaudo-api",
                        setComponentState: false,
                    });
                    this.setState({ loadingEmail: false });
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    limpiarValoresFormulario() {
        sessionStorage.removeItem("detalleFormulario");
        this.props.history.push(ruta.home)
    }

    render() {

        return (
            <Elastic felx={"1 0 auto"}
                className={"wc cambio"}
                css={css`animation:  ${Transition}  .8s cubic-bezier(0.075, 0.820, 0.165, 1.000) 1;`}

            >
                <Mycard
                    title={this.state.titulo}
                    // back={"/facturas"}
                    className={" col-12 col-lg-10 mx-auto px-0"}
                    footer={this.state.informacionEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.informacionEmpresa} />}
                    history={this.props.history}


                >
                    <div className="wc px-lg-4 px-md-3 ">

                        <div className="col-12">
                            <Alert alert={this.verificarEstadoTransaccion(this.state.response.x_cod_response)}
                                className={"mb-3"}>
                                {`Pago ${this.validateStatus()}`}
                            </Alert>
                            {this.state.integrationErrorMessage && (
                                <div className="col-12 mb-3 text-center">
                                    <p className="cg mb-3">{this.state.integrationErrorMessage}</p>
                                    <Btn bg hg={"45"} onClick={this.loadTransaction}>
                                        Reintentar consulta
                                    </Btn>
                                </div>
                            )}
                        </div>
                        {!this.state.errorPago && (
                            <Flex
                                className={"wc pb-3 align-items-start"}
                            >
                                <div className="col-12 col-md-6 pl-md-0 ">
                                    <p className={"cg mb-0"}>Detalle del formulario</p>

                                    {this.state.infoFormulario.map((inf, key) => (
                                        <Flex key={`details-fields-${key}`}>
                                            {inf.help && inf.help !== "" &&
                                                <ReactTooltip id={`help-${key}`} place="right" type="info" effect="solid">
                                                    {inf.help}
                                                </ReactTooltip>
                                            }
                                            <div className="col-6 pl-0 cg c0">
                                                <small data-tip data-for={`help-${key}`}><b>{inf.name}</b></small>
                                            </div>
                                            <div className="col-6 pr-0 cg text-right">
                                                <small>{this.tranformValue(inf.value, inf.fieldType, inf.fieldOptions, inf.fieldDb)}</small>
                                            </div>
                                            <Line dotted />
                                        </Flex>
                                    ))}
                                    {this.state.existeProductos && <React.Fragment>
                                        <Flex jc={"space-between"}
                                            className={"pt-15"}
                                        >
                                            <div className={"cg"}>Resumen de productos</div>
                                            <div className={"cg"}>Cantidad</div>
                                            <Line dotted className={"wc"} />
                                        </Flex>
                                        {this.state.productos.map((inf, key) => (
                                            <Flex key={`details-fields-${key}`}>
                                                {inf.help && inf.help !== "" &&
                                                    <ReactTooltip id={`help-${key}`} place="right" type="info" effect="solid">
                                                        {inf.help}
                                                    </ReactTooltip>
                                                }
                                                <div className="col-6 pl-0 cg c0">
                                                    <small data-tip data-for={`help-${key}`}><b>{inf.name}</b></small>
                                                </div>
                                                <div className="col-6 pr-0 cg text-right">
                                                    <small>{this.tranformValue(inf.value, inf.fieldType, inf.fieldOptions, inf.fieldDb)}</small>
                                                </div>
                                                <Line dotted />
                                            </Flex>
                                        ))}
                                    </React.Fragment>}

                                </div>
                                <div className="col-12 col-md-6 pr-md-0 pt-4 pt-md-0 ">
                                    <p className={"cg mb-0"}>Detalle de la transacción</p>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Referencia</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_id_invoice}</small>
                                        </div>
                                        <Line dotted />
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Referencia ePayco</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_ref_payco}</small>
                                        </div>
                                        <Line dotted />
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>IP origen</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_customer_ip}
                                            </small>
                                        </div>
                                        <Line dotted />
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Método de pago</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_franchise}
                                                - {this.state.response.x_cardnumber}</small>
                                        </div>
                                        <Line dotted />
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Número de recibo</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{this.state.response.x_id_invoice}</small>
                                        </div>
                                        <Line dotted />
                                    </Flex>

                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Subtotal</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{`$ ${parseFloat(this.state.response.x_amount_base ? this.state.response.x_amount_base : 0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} COP`}</small>
                                        </div>
                                        <Line dotted />
                                    </Flex>
                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Iva</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{`$ ${parseFloat(this.state.response.x_tax ? this.state.response.x_tax : 0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} COP`}</small>
                                        </div>
                                        <Line dotted />
                                    </Flex>
                                    <Flex>
                                        <div className="col-6 pl-0 cg c0">
                                            <small><b>Total pago</b></small>
                                        </div>
                                        <div className="col-6 pr-0 cg text-right">
                                            <small>{`$ ${parseFloat(this.state.response.x_amount ? this.state.response.x_amount : 0).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} COP`}</small>
                                        </div>
                                    </Flex>

                                </div>
                            </Flex>
                        )}


                        <Flex alg={"flex-end"} className="fixed-to-bottom txt-aln-ctn">
                            {!this.state.errorPago && (
                                <Flex className={this.state.url_respuesta.activo ? "col-12 col-md-7 px-0 pb-3 pb-md-0 px-md-0 " : "col-12 col-md-9 px-0 pb-3 pb-md-0 px-md-0 "}>
                                    {!this.state.printState && (
                                        <ShowEmail
                                            url_respuesta={this.state.url_respuesta}
                                            show={() => this.setState({
                                                email: !this.state.email
                                            })}
                                            email={this.state.email}
                                            loading={this.state.loading}
                                            loadingEmail={this.state.loadingEmail}
                                            downloadPdf={this.downloadPdf.bind(this)}
                                            print={this.print.bind(this)}
                                            onChangeInputText={this.onChangeInputText.bind(this)}
                                            sendEmail={this.sendEmail.bind(this)}
                                            enviado={this.state.enviado}
                                            error={this.validator.message('email', this.state.textEmail, ['required', { regex: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$' }])}
                                        />
                                    )}
                                    <a hidden id="pdf"></a>
                                </Flex>
                            )}

                            {!this.state.printState && (
                                this.state.url_respuesta.activo ?
                                    (
                                        <div
                                            className="col-12 col-md-5 px-0 pb-3 pb-md-0 px-md-0 btn-aln">
                                            <div className="col-12 col-md-6 pb-3 pb-md-0 pl-md-0 btn-bar-font">
                                                <Btn
                                                    className="btn-bar-font"
                                                    classNameBtn="btn-vertical-aln"
                                                    bg
                                                    onClick={() => this.props.history.push(ruta.home)}
                                                    hg={"45"}
                                                >
                                                    <img
                                                        src={require('../../assets/CreditCard.svg')}
                                                        alt="" width={"27px"} height={"auto"} className={"mr-2"} />
                                                    Pagar otra factura
                                                </Btn>
                                            </div>
                                            <div className="col-12 col-md-6 pb-3 pb-md-0 pl-md-0 btn-bar-font">
                                                <Btn
                                                    className="btn-bar-font"
                                                    classNameBtn="btn-vertical-aln"
                                                    onClick={() => {
                                                        window.location = this.state.url_respuesta.url;
                                                    }}
                                                    hg={"45"}>Volver al comercio</Btn>
                                            </div>
                                        </div>
                                    ) :
                                    (
                                        <div className="col-12 col-md-3 px-md-0">
                                            <Btn classNameBtn="btn-vertical-aln" onClick={() => this.props.history.push(ruta.home)} hg={"45"}>Finalizar</Btn>
                                        </div>
                                    )
                            )}
                        </Flex>

                    </div>
                </Mycard>
            </Elastic>
        )
    }
}

export default withRouter(InicioFormulario);
